import React from 'react'

import { useLightMode } from '@/hooks/useLightMode'

import { Input, InputProps } from '@chakra-ui/react'

const CRITERION_INPUT_WIDTHS = {
  withModelDropdown: {
    maxWidth: {
      base: '45px',
      sm: '60px',
      md: '90px',
      lg: '110px',
    },
    minWidth: {
      base: '45px',
      sm: '60px',
      md: '90px',
      lg: '110px',
    },
  },
  withoutModelDropdown: {
    maxWidth: {
      base: '60px',
      sm: '80px',
      md: '130px',
      lg: '150px',
    },
    minWidth: {
      base: '60px',
      sm: '80px',
      md: '130px',
      lg: '150px',
    },
  },
} as const

interface AiOperatorCriterionInputIProps extends Omit<InputProps, 'value'> {
  value: string
  showModelDropdown?: boolean
}

export const AiOperatorCriterionInput = ({
  value,
  isDisabled,
  showModelDropdown = false,
  ...rest
}: AiOperatorCriterionInputIProps) => {
  const mode = useLightMode()
  const inputWidths = showModelDropdown
    ? CRITERION_INPUT_WIDTHS.withModelDropdown
    : CRITERION_INPUT_WIDTHS.withoutModelDropdown

  return (
    <Input
      _focus={{ border: 'none', boxShadow: 'none' }}
      _hover={{ border: 'none' }}
      backgroundColor={isDisabled ? `bg.disabled.${mode}` : `bg.input.${mode}`}
      // Borderless like the sibling selects; the bg.input fill provides the
      // contrast against the card
      border='none'
      borderRadius='lg'
      color={`text.primary.${mode}`}
      cursor={isDisabled ? 'not-allowed' : 'default'}
      isDisabled={isDisabled}
      isReadOnly
      {...inputWidths}
      pointerEvents='none'
      size='sm'
      tabIndex={-1}
      value={value}
      {...rest}
    />
  )
}
